import angular from 'angular';

import HealthcarebookHomeComponent from './home.component';

export default angular.module('healthcarebookHome', [])
    .component('healthcarebookHomeComponent', HealthcarebookHomeComponent)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/home/home.module.js
// module id = 343
// module chunks = 0